import { HttpContext, HttpContextToken } from '@angular/common/http';

export const CLIENT_ID_HEADER = 'X-Client-Id';
export const VENDOR_ID_HEADER = 'X-Vendor-Id';
export const IMPERSONATION_SESSION_HEADER = 'X-Impersonation-Session-Id';
export const TIMEZONE_HEADER = 'X-Timezone';
export const CORRELATION_ID_HEADER = 'X-Correlation-ID';
export const ASSESSMENT_ID_HEADER = 'X-Assessment-Id';

export interface HeaderInjectionPolicy {
  skippedHeaders: ReadonlySet<string>;
}

const EMPTY_HEADER_POLICY: HeaderInjectionPolicy = {
  skippedHeaders: new Set<string>(),
};

export const HEADER_INJECTION_POLICY = new HttpContextToken<HeaderInjectionPolicy>(() => EMPTY_HEADER_POLICY);

function normalizeHeaderName(name: string): string {
  return name.trim().toLowerCase();
}

export function skipInjectedHeaders(context: HttpContext | undefined, headers: readonly string[]): HttpContext {
  const target = context ?? new HttpContext();
  const current = target.get(HEADER_INJECTION_POLICY);
  const merged = new Set(current.skippedHeaders);

  for (const header of headers) {
    merged.add(normalizeHeaderName(header));
  }

  target.set(HEADER_INJECTION_POLICY, { skippedHeaders: merged });
  return target;
}

export function isHeaderSkippedByPolicy(context: HttpContext, headerName: string): boolean {
  const normalized = normalizeHeaderName(headerName);
  return context.get(HEADER_INJECTION_POLICY).skippedHeaders.has(normalized);
}
